
<div class="modal-dialog modal-lg">
  <div class="modal-content p-3">
    <div class="modal-header border-bottom-0">
      <h4 class="modal-title">Credit Check Log</h4>
      <button class="close" type="button" (click)="close()">&times;</button>
    </div>
    <div class="modal-body container-fluid">
      <table class="table table-bordered tableFixedHeader" *ngIf="creditCheckLogs.length &gt; 0; else noLogs">
        <thead>
          <th class="text-secondary" style="width: 110px">Date</th>
          <th class="text-secondary" style="width: 80px">Time</th>
          <th class="text-secondary" style="width: 110px">Status</th>
          <th class="text-secondary">Message</th>
        </thead>
        <tbody>
          <tr *ngFor="let log of creditCheckLogs">
            <td style="width: 110px">{{log.createdAt | date: 'yyyy-MM-dd'}}</td>
            <td style="width: 80px">{{log.createdAt | date: 'hh:mm'}}</td>
            <td style="width: 110px" [ngStyle]="{'color':log.responseSuccess ? 'green' : 'red' }">{{log.responseSuccess ? 'Passed' : 'Did Not Pass'}}</td>
            <td>
              <ul *ngIf="log.response &amp;&amp; log.response.checkingDescription">
                <li *ngFor="let message of log.response.checkingDescription.messages">{{message}}</li>
              </ul><span *ngIf="log.notes">{{log.notes}}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <ng-template #noLogs>
        <p class="text-secondary bold">There are no logs for this {{selector}} yet.</p>
      </ng-template>
    </div>
  </div>
</div>